import React, { useState } from "react";
import { Link } from "react-router-dom";
import { searchJobs } from "../api/api";
import "./Search.css";

function getTimestampFromObjectId(id) {
  if (!id || typeof id !== "string" || id.length < 8) return 0;
  const hex = id.slice(0, 8);
  const ts = parseInt(hex, 16);
  return Number.isNaN(ts) ? 0 : ts * 1000;
}

function sortNewestFirst(items = []) {
  return [...items].sort((a, b) => {
    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : getTimestampFromObjectId(a?._id);
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : getTimestampFromObjectId(b?._id);
    return bTime - aTime;
  });
}

function Search() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) {
      setResults([]);
      return;
    }

    setLoading(true);
    try {
      const res = await searchJobs(query);
      setResults(sortNewestFirst(Array.isArray(res.data) ? res.data : []));
    } catch (err) {
      console.error("Search error:", err);
      setResults([]);
    }
    setLoading(false);
  };

  return (
    <div className="search-page-wrapper">
      <div className="search-container">
        <div className="search-header">
          <h1>Job Search</h1>
          <p>Find your perfect job opportunity</p>
        </div>
      
        <form onSubmit={handleSearch} className="search-form">
          <input
            type="text"
            placeholder="Search by job title or slug..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit">Search</button>
        </form>

        {loading && <p className="search-loading">Loading results...</p>}

        {results.length > 0 && (
          <div>
            <h2 className="search-results-header">Found {results.length} results</h2>
            <table className="search-results-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Slug</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {results.map((job) => (
                  <tr key={job._id}>
                    <td>
                      <Link to={`/mform/${job.slug}`}>{job.title}</Link>
                    </td>
                    <td>{job.slug}</td>
                    <td>
                      <Link className="search-view-link" to={`/mform/${job.slug}`}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Search;
